import { render, staticRenderFns } from "./SpecificationsAndInventory.vue?vue&type=template&id=ce219688&scoped=true"
import script from "./SpecificationsAndInventory.vue?vue&type=script&lang=js"
export * from "./SpecificationsAndInventory.vue?vue&type=script&lang=js"
import style0 from "./SpecificationsAndInventory.vue?vue&type=style&index=0&id=ce219688&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce219688",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce219688')) {
      api.createRecord('ce219688', component.options)
    } else {
      api.reload('ce219688', component.options)
    }
    module.hot.accept("./SpecificationsAndInventory.vue?vue&type=template&id=ce219688&scoped=true", function () {
      api.rerender('ce219688', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/creatStore/steps/SpecificationsAndInventory.vue"
export default component.exports